import { helper } from '@/utils'
import Logo from '../Logo/Logo.vue'
import Company from '../Company/Company.vue'

export default {
  name: 'Confirmation',
  components: { Company, Logo },
  computed: {
    isMobile: helper.isMobile
  },
  data () {
    return {
      appleStore: '',
      component: 'confirmation',
      footer: {},
      googlePlay: '',
      primaryColor: '#00BAFF',
      title: '',
      url: '',
      welcomeBody: '',
      openAppButton: 'Open App',
      lang: this.$route.params.lang || ''
    }
  },
  methods: {
    getData () {
      return this.getTheme()
        .then(theme => {
          this.footer = {
            companyAddress: theme.company_address,
            companyContact: theme.company_contact,
            companyName: theme.company_name,
            companyUrl: theme.company_url
          }
          this.primaryColor = theme.primary_color
          this.googlePlay = theme.google_play
          this.appleStore = theme.apple_store
          this.url = theme.app_url_scheme + location.host
          if (this.lang === 'zh-TW') {
            let title = '歡迎使用 {{product_name}}！'
            let welcomeBody = '藉由 {{app_name}} app，您可以在任何地方遠端遙控您的裝置並且創建排程。若您尚未安裝 {{app_name}} app，請參考下載連結。'
            this.title = this.getReplacedString(title, theme)
            this.welcomeBody = this.getReplacedString(welcomeBody, theme)
            this.openAppButton = '開啟 App'
          } else {
            this.title = this.getReplacedString(theme.welcome_web_headline, theme)
            this.welcomeBody = this.getReplacedString(theme.welcome_web_body, theme)
          }
        })
        .then(() => {
          return this.activeUser(this.$route.params.token)
        })
        .catch((error) => {
          this.$router.push('/404')
          helper.showErrorMessage(this, this.component, error)
        })
    },
    getTheme () {
      return this.$api.getTheme()
        .then(({ body }) => body)
    },
    getReplacedString (string, theme) {
      return (string || '')
        .replace(/{{product_name}}/g, theme.product_name)
        .replace(/{{app_name}}/g, theme.app_name)
    },
    activeUser (token) {
      return this.$api.activeUser(token)
      .then(({ body }) => body)
    }
  },
  mounted () {
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/assets/pages/Confirmation/Confirmation.js